import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { filter, pairwise } from 'rxjs/operators';
import { ActivationStart, Router } from '@angular/router';
import { RouteLoggingService } from './_services/route-logging/route-logging.service';
import { logRouteRequest } from './_models/route-logger/log-route-request.model';
import { BreadcrumbService } from './_helpers/breadcrumb/breadcrumb.service';
import { LoadingService } from './_services/loading/loading.service';
import { MonitoringService } from './_services/monitoring/monitoring.service';
import { Observable } from 'rxjs';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {

  title = 'app';
  isLoading$: Observable<boolean>;
  @ViewChild('spinnerPortal') spinnerPortal: ElementRef<HTMLDivElement>;

  constructor(
    private router: Router,
    private routeLoggerService: RouteLoggingService,
    private breadcrumbService: BreadcrumbService,
    private loadingService: LoadingService,
    private monitoringService: MonitoringService
  ) {
    this.isLoading$ = this.loadingService.isLoading$;
    this.router.events
    .pipe(
      filter(event => event instanceof ActivationStart),
      pairwise()
    )
    .subscribe((event: [ActivationStart, ActivationStart]) => {
      let fromPath = event[0].snapshot.url.length > 0 ? '/' + event[0].snapshot.url[0].path : "";
      let toPath = event[1].snapshot.url.length > 0 ? '/' + event[1].snapshot.url[0].path : "";
      this.logRouteChange(fromPath, toPath);
      if (event[1].snapshot.data.breadcrumb) {
        this.breadcrumbService.setBreadcrumb(event[1].snapshot.data['breadcrumb']);
      }
    }); 

    this.logRouteChange("", window.location.pathname);
  }

  ngOnInit() {}

  ngAfterViewInit(): void {
    document.body.appendChild(this.spinnerPortal.nativeElement);
  }

  ngOnDestroy(): void {
    const el = this.spinnerPortal?.nativeElement;
    if (el?.parentElement === document.body) {
      document.body.removeChild(el);
    }
  }

  private logRouteChange(from: string, to: string): void {
    let request = new logRouteRequest;
    request.routeFrom = from;
    request.routeTo = to;

    this.routeLoggerService.logRoute(request).subscribe();
    
  }
  
}
